<template>
    <!-- <div class="item-grid-view vx-row match-height">
        <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
            <vx-card class="grid-view-item mb-base overflow-hidden" v-on="$listeners" @click="navigate_to_login">
                <template slot="no-body">
                    <div class="container-fluid">
                        <div id="search" class="row">
                            <div class="col-sm-4">
                                <div class="row">
                                <!-- ITEM IMAGE -->
                                <div class="item-img-container bg-white h-64imagen flex items-center justify-center mb-4 cursor-pointer">
                                    <img :src="item.imagen?('data:image/png;base64,'+item.imagen+''):defaultImageURL" :alt="item.nomart" class="grid-view-img px-4">
                                </div>
                                </div>
                                <div class="">
                                     <!-- <div class="my-4"> -->
                                        <h6 v-for="clase in item.clases" :key="clase" 
                                            class="font-semibold mb-1 hover:text-primary cursor-pointer " >
                                            {{ clase || 'N/A' }}
                                        </h6>
                                    <!-- </div> -->
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <div class="item-details px-4">

                                    <!-- PRICE -->
                                    <div class=" row my-4">
                                        <!-- <div></div> -->
                                        <div class="col hormar">
                                            <div class="row">
                                        <h6 class="horario">{{ horaAtencion()}}</h6>
                                        <h6 class="horario" :style="this.color">{{ this.estado }}</h6>
                                            </div>
                                        </div>
                                        <i class="far fa-calendar-alt 2x iconcolor"></i>
                                    </div>

                                    <!-- CODART -->
                                    <div class="my-4">
                                        <h6 class="font-semibold mb-1 hover:text-primary cursor-pointer " >{{ item.nomcom || 'N/A' }}</h6>
                                        <!-- <p class="item-description truncate text-sm">{{ item.value }}</p> -->
                                        <p class="">{{ item.dircom || 'N/A' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- SLOT: ACTION BUTTONS -->
                    <slot name="action-buttons" />
                </template>
            </vx-card>
       <!--  </div>
    </div> -->
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

export default{
  data () {
    return {
        defaultImageURL: require('@/assets/images/elements/not-available-es.png'),
        estado: '',
        color: ''
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  computed: {
  },
  methods: {
    horaAtencion(){
        if(this.item.horaini && this.item.horafin){

        return this.item.horaini.substring(0, 2) + 'H00 a ' + 
               this.item.horafin.substring(0, 2)+ 'H00 | ' + ' '
        }else{
            return ''
        }
    },
    abiertoc(){
        if(this.item.horaini && this.item.horafin){
            if(moment(new Date()).format('HH') >= this.item.horaini.substring(0, 2)
                && moment(new Date()).format('HH') < this.item.horafin.substring(0, 2)){
                    this.estado = ' Abierto'
                    this.color = 'color:#4ce04c'
            }else{
                    this.estado = ' Cerrado'
                    this.color = 'color:red'
            }
        }
    },
    navigate_to_login () {
      var a = this.item
      var newurl = `${a.servurl}`;
      if (a.puerto && a.puerto != "") {
        newurl += `:${a.puerto}`;
      }
      localStorage.setItem("urlemp", newurl);
      this.$router.push({name: 'page-login'})
        .catch(() => {})
    }
  },
  created(){
    this.abiertoc()
  }
}
</script>

<style lang="scss" scoped>
.grid-view-item {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
.horario{
    font-size: 12px;
}
.iconcolor {
    color: black;
    font-size: large;
    align-items: right !important;
}
.hormar{
    margin-left: 1rem;
}
.h-64imagen {
    height: 8rem !important;
}
</style>
